// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3gCtb","productName":"Table_productName__agGJc"};